
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/posts",
      function () {
        return require("private-next-pages/content/posts/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/posts"])
      });
    }
  